import { useCurrentStateAndParams } from "@uirouter/react";

import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import { AIAgentChatPrint } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/download-pdf/components/AIAgentChatPrint/AIAgentChatPrint";
import { AIAgentMeetingErrorView } from "app/pages/sales-intelligence/pages/ai-agent/components/AIAgentMeetingErrorView/AIAgentMeetingErrorView";
import AIAgentMeetingPageContent from "app/pages/sales-intelligence/pages/ai-agent/containers/AIAgentMeetingPageContent";

const AIAgentMeetingPageContainer = () => {
    const {
        params: { messageId },
    } = useCurrentStateAndParams<{ messageId?: string }>();

    return (
        <ErrorBoundaryWithLogging FallbackComponent={AIAgentMeetingErrorView}>
            {messageId ? <AIAgentChatPrint /> : <AIAgentMeetingPageContent />}
        </ErrorBoundaryWithLogging>
    );
};

export default AIAgentMeetingPageContainer;
